import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {IboxxSideBarComponent} from './iBoxx/iboxx-side-bar/iboxx-side-bar.component';
import {IboxxIndexDetailsPageComponent} from './iBoxx/iboxx-index-details-page/iboxx-index-details-page.component';
import {IboxxScreenerPageComponent} from './iBoxx/iboxx-screener-page/iboxx-screener-page.component';
import {SideNavLibModule} from 'ihsm-side-nav-lib-ng7';
import {IboxxNewsPageComponent} from './iBoxx/iboxx-news-page/iboxx-news-page.component';
import {AgGridModule} from 'ag-grid-angular';
import {TabBarComponent} from './iBoxx/shared/tab-bar/tab-bar.component';
import {DataSharingService} from './iBoxx/services/data-sharing.service';
import {ScreenerFiltersComponent} from './iBoxx/screener-filters/screener-filters.component';
import {FormsModule} from '@angular/forms';
import {ApiService} from './iBoxx/services/api.service';
import {HttpClientModule} from '@angular/common/http';
import {LoaderComponent} from './iBoxx/shared/loader/loader.component';
import {LoaderService} from './iBoxx/shared/loader/loader-service.services';
import {PaginationControlComponent} from './iBoxx/shared/pagination-control/pagination-control.component';
import {UtilService} from './iBoxx/services/UtilService';
import {ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ChartPageComponent} from './iBoxx/chart-page/chart-page.component';
// tslint:disable-next-line:import-spacing
import {IndexPerformanceAnalyticsPageComponent} from
    './iBoxx/index-performance-analytics-page/index-performance-analytics-page.component';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import {IhsmAlertNotificationModule} from 'ihsm-alert-notification';
import {IndexProfilePageComponent} from './iBoxx/index-profile-page/index-profile-page.component';
import {IndexCostituentPageComponent} from './iBoxx/index-costituent-page/index-costituent-page.component';
import {HeaderPageComponent} from './iBoxx/header-page/header-page.component';
import {FooterPageComponent} from './iBoxx/footer-page/footer-page.component';
import {CustomUrlSerializer} from './CustomUrlSerializer';
import {UrlSerializer} from '@angular/router';
import {NgxsModule} from '@ngxs/store';
import {NgxsStoragePluginModule} from '@ngxs/storage-plugin';
import {ScreenerFilterState} from './iBoxx/ngxs/screener-filter.state';
import {CarbonLandingPageComponent} from './carbon/carbon-landing-page/carbon-landing-page.component';
import {CarbonIndexDetailPageComponent} from './carbon/carbon-index-detail-page/carbon-index-detail-page.component';
import {IhsmDropdownLibModule} from './iBoxx/shared/ihsm-dropdown-lib/ihsm-dropdown-lib.module';
import {RangeDateSelectComponent} from './iBoxx/shared/range-date-select/range-date-select.component';
import { CustomTooltipComponent } from './iBoxx/shared/custom-tooltip/custom-tooltip.component';
import { LoadingTextComponent } from './iBoxx/shared/loading-text/loading-text.component';
import { SkeletonLoaderComponent } from './iBoxx/shared/skeleton-loader/skeleton-loader.component';
import { IndicesDocsPageComponent } from './indices-docs-page/indices-docs-page.component';
import {ScreenerPageState} from './iBoxx/ngxs/screener-page.state';
import { FuturesScreenerPageComponent } from './iBoxx/futures-screener-page/futures-screener-page.component';
import { FuturesDocumentPageComponent } from './iBoxx/futures-document-page/futures-document-page.component';
import { TrsScreenerPageComponent } from './iBoxx/trs-screener-page/trs-screener-page.component';
import { TrsDocumentPageComponent } from './iBoxx/trs-document-page/trs-document-page.component';
import { EsgScreenerPageComponent } from './iBoxx/esg-screener-page/esg-screener-page.component';
import { EsgDocumentPageComponent } from './iBoxx/esg-document-page/esg-document-page.component';
import {IndexStateState} from './iBoxx/ngxs/index-state.state';
import { DownloadLinkModalComponent } from './download-link-modal/download-link-modal.component';
import { EmixLandingPageComponent } from './EMIX/emix-landing-page/emix-landing-page.component';
import { EmixDetailsPageComponent } from './EMIX/emix-details-page/emix-details-page.component';
import { EmixDocumentPageComponent } from './EMIX/emix-document-page/emix-document-page.component';
import { TrsCalcPageComponent } from './iBoxx/trs-calc-page/trs-calc-page.component';
import { HeaderPageSpdjiComponent } from './header-page-spdji/header-page-spdji.component';
import { FooterPageSpdjiComponent } from './footer-page-spdji/footer-page-spdji.component';
import { UcitsLandingPageComponent } from './ucits-landing-page/ucits-landing-page.component';
import { UcitsDetailsPageComponent } from './ucits-details-page/ucits-details-page.component';
import { HealthCheckComponent } from './health-check/health-check.component';

@NgModule({
  declarations: [
    AppComponent,
    CarbonLandingPageComponent,
    CarbonIndexDetailPageComponent,
    IboxxSideBarComponent,
    IboxxIndexDetailsPageComponent,
    IboxxScreenerPageComponent,
    IboxxNewsPageComponent,
    TabBarComponent,
    ScreenerFiltersComponent,
    LoaderComponent,
    PaginationControlComponent,
    ChartPageComponent,
    IndexPerformanceAnalyticsPageComponent,
    IndexProfilePageComponent,
    IndexCostituentPageComponent,
    HeaderPageComponent,
    FooterPageComponent,
    RangeDateSelectComponent,
    CustomTooltipComponent,
    LoadingTextComponent,
    SkeletonLoaderComponent,
    IndicesDocsPageComponent,
    FuturesScreenerPageComponent,
    FuturesDocumentPageComponent,
    TrsScreenerPageComponent,
    TrsDocumentPageComponent,
    EsgScreenerPageComponent,
    EsgDocumentPageComponent,
    DownloadLinkModalComponent,
    EmixLandingPageComponent,
    EmixDetailsPageComponent,
    EmixDocumentPageComponent,
    TrsCalcPageComponent,
    HeaderPageSpdjiComponent,
    FooterPageSpdjiComponent,
    UcitsLandingPageComponent,
    UcitsDetailsPageComponent,
    HealthCheckComponent
  ],
  imports: [
    BrowserModule,
    AgGridModule.withComponents([]),
    NgxsModule.forRoot(
      [ScreenerFilterState, ScreenerPageState, IndexStateState]
    ),
    NgxsStoragePluginModule.forRoot(),
    AppRoutingModule,
    SideNavLibModule,
    IhsmDropdownLibModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbDatepickerModule,
    IhsmAlertNotificationModule,
    IhsmDropdownLibModule,
  ],
  providers: [
    DataSharingService,
    ApiService,
    LoaderService,
    UtilService,
    ScreenerFilterState,
    {provide: UrlSerializer, useClass: CustomUrlSerializer},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
